import API_PATHS from '@dealstack/shared/lib/generated/apiPaths';
import { ServiceRequestOptions } from '@dealstack/frontend/shared/other/react/ApiWrapper/types.ts';
import { makeRequest } from '@dealstack/frontend/shared/dataExchange/ApiLayer/apiLayer.ts';
import { HTTP_METHOD } from '@dealstack/shared/lib/common/dataExchange/common.ts';
import {
	ProgrammeSettingResponseDto,
	UpdateProgrammeSettingDto,
} from '@dealstack/shared/lib/generated';

export const getProgrammeSetting = async (options?: ServiceRequestOptions) => {
	return await makeRequest<{ payload: ProgrammeSettingResponseDto }>(
		{
			endpoint: API_PATHS.PROGRAMME_SETTING_MIP_GET,
			method: HTTP_METHOD.GET,
		},
		{
			...options,
		}
	);
};

export const updateProgrammeSetting = async (
	data: UpdateProgrammeSettingDto,
	options?: ServiceRequestOptions
) => {
	return await makeRequest<{ payload: ProgrammeSettingResponseDto }>(
		{
			endpoint: API_PATHS.PROGRAMME_SETTING_MIP_PUT,
			method: HTTP_METHOD.PUT,
			body: JSON.stringify(data),
		},
		{
			...options,
		}
	);
};
